module.exports = __webpack_public_path__ + "img/logo-orcamento-participativo-branco.f722a5b2.svg";